import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { CustomerCommentTag } from '../models';
import { AbstractApiService } from '../../shared/services';
import { AbstractApiResponse } from '../../shared/models';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class CustomerCommentTagsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  getCustomerCommentTag(uuid: string): Observable<CustomerCommentTag> {
    return this.rolesService.userHasRoleFilter<CustomerCommentTag>(
      'ROLE_MWS_CUSTOMER_COMMENT_VIEW',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(
              `/api/customer_comment_tags/${uuid}`,
              true
            )
    );
  }

  getCustomerCommentTags(): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_CUSTOMER_COMMENT_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(`/customer_comment_tags`)
    );
  }
}
